import { isUwp } from '@office-start/device-detection-utility';
export function isValidAppVersion(version) {
    if (isUwp()) {
        if (typeof window.Office !== 'undefined') {
            var wrapperVersion = Windows.ApplicationModel.Package.current.id.version;
            // In case of WebView2, isValid if its the same as current version passed or higher
            if (wrapperVersion.minor > version.minor ||
                (wrapperVersion.minor === version.minor &&
                    wrapperVersion.build >= version.build)) {
                return true;
            }
            else {
                // Not valid for lower versions
                return false;
            }
        }
        else {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=isValidAppVersion.js.map